import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import "../../../mcss/main.css";
import ActivityLog from '../../ActivityLog';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import Tran_data_unlock_request from '../../Tran_data_unlock_request';
function Modification_commission() {


    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");
    const userSrno = sessionStorage.getItem("userSrno");
    const [scrMode, setScrMode] = useState('');
    const [commissionDisable, setCommissionDisable] = useState(false);
    const [filtertransaction, setFiltertransaction] = useState('PP');
    const [onceRun, setOnceRun] = useState(false);
    const [pProductList, setPProductList] = useState([]);
    const [commType, setCommType] = useState("");
    const [commValue, setCommValue] = useState("");
    const [pAgent, setPAgent] = useState(null);
    const [ppLocationValue, setPPLocationValue] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);

    const [msgTextYN, setMsgTextYN] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [ppNewDate, setPPNewDate] = useState(new Date());

    const [ppLocation, setPPLocation] = useState(null);
    const [userRight, setUserRight] = useState([]);

    const [hdrLocation, setHdrLocation] = useState("");
    const [ppSrnoFrom, setPPSrnoFrom] = useState("");
    const [ppSrnoTo, setPPSrnoTo] = useState("");
    const [commissionData, setCommissionData] = useState([]);
    const [commissionDataToDelete, setCommissionDataToDelete] = useState([]);
    const [editbtnView, setEditbtnView] = useState(true);
    const [isSaveDialogOpen, setSaveDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [saveMsgTextYN, setSaveMsgTextYN] = useState("Are you sure you want to save?");
    const [deleteMsgTextYN, setDeleteMsgTextYN] = useState("Are you sure you want to delete?");
    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [compareData, setCompareData] = useState([]);
    const [headerList, setHeaderList] = useState([]);
    const [editbtnHeaderView, setEditbtnHeaderView] = useState(true);
    const [compareHeaderData, setCompareHeaderData] = useState([]);
    const [headerDisableCodition, setHeaderDisableCondition] = useState(false);
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [unlockRequestType, setUnlockRequestType] = useState("");



    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setPPLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'COMMISSION_MODIFICATION'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        const sessionValues = sessionStorage.getItem('values');
        if (sessionValues) {
            const sessionData = JSON.parse(sessionValues);
            if (sessionData.md_type == "PURCHASE") {
                setScrMode('A');
                // setNServiceType('R');
                Common.callApi(Common.apiIndividualProfile, [sid, 'getIndividualData', sessionData.code], (result) => {
                    let resp = JSON.parse(result);
                });
                sessionStorage.removeItem('values');
            } else {
                setScrMode('');
            }
        }
    }, []);
    const handleLocationChange = (value) => {
        setPPLocation(value);
        var id = value.id;
        var location = id.split("^");
        setPPLocationValue(location[1]);
        setHdrLocation(location[2]);
        setPProductList([]);
        setEditbtnHeaderView(true)
        sessionStorage.activeBranch = location[1];
    }

    const applyFilter = (srno, location, prdtype) => {
        $(".loader").show();
        // setCommissionDisable(true);
        var msg = [], i = 0;
        if (ppSrnoFrom === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (ppSrnoFrom === "" ? "Srno" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            var obj = {
                location: ppLocationValue,
                transaction: filtertransaction,
                srnofrom: ppSrnoFrom,
                srnoto: ppSrnoTo
            }
            Common.callApi(Common.apiModiCommission, [sid, "trandetailview", JSON.stringify(obj)], function (result) {
                let resp = JSON.parse(result);
                // console.log(resp);
                if (resp.trandetailproduct.length > 0) {
                    setPProductList(resp.trandetailproduct);
                    setHeaderList(resp.tranheader);
                    $(".loader").hide();
                    setEditbtnView(true);
                } else {
                    $(".loader").hide();
                    setPProductList([]);
                    setHeaderList([]);
                    setMsgText("Data Not Found");
                    setMsgBox(true);
                }
                setEditbtnHeaderView(true);
            })
        }

    }
    const handleAgentChange = (value, uniquekey) => {
        // console.log(value);
        const itemToUpdate = pProductList.find(item => item.uniquekey === uniquekey);

        if (!itemToUpdate) return;

        const { prd_qty, prd_deno, prd_rate, prd_isd, prd_product } = itemToUpdate;

        Common.callApi(Common.apiLedger, [sid, "getisdcommission", value.id, prd_isd, prd_product], result => {
            const resp = JSON.parse(result);
            let commvalue;

            if (resp.type === "P" || resp.type === "R") {
                commvalue = calcCommission(resp.value, resp.type, prd_qty, prd_deno, prd_rate);
                console.log("Calculated commission using type P/R");
            } else {
                commvalue = resp.value;
                console.log("Directly set commission value for type F");
            }

            // Update commission value and type in specific row
            setPProductList(prevData =>
                prevData.map(row =>
                    row.uniquekey === uniquekey
                        ? { ...row, prd_agent_name: value.label, prd_agent_group: value.id.split('^')[1], prd_agent_ledger: value.id.split('^')[2], prd_commission_value: commvalue, prd_commission: resp.value, prd_commission_type: resp.type }
                        : row
                )
            );
        });
    };
    //console.log(pProductList);
    const commissionTypeChange = (v, uniquekey) => {
        setPProductList(prevData =>
            prevData.map(row =>
                row.uniquekey === uniquekey
                    ? { ...row, prd_commission_type: v, prd_commission_value: "", prd_commission: "" }
                    : row
            )
        );
    };

    const handleCommissionCalc = (v, uniqueKey) => {
        const itemToUpdate = pProductList.find(item => item.uniquekey === uniqueKey);
        if (!itemToUpdate) return; // Check if item exists

        const { prd_qty: quantity, prd_deno: denomination, prd_rate: rate, prd_commission_type: commissionType } = itemToUpdate;
        setPAgent(v);

        Common.validateDecValue(v, (validatedValue) => {
            const calculatedValue = calcCommission(validatedValue, commissionType, quantity, denomination, rate);

            setPProductList(prevList =>
                prevList.map(item =>
                    item.uniquekey === uniqueKey
                        ? { ...item, prd_commission: validatedValue, prd_commission_value: calculatedValue }
                        : item
                )
            );

            // Update `commValue` to be used directly in the UI for the specific uniqueKey
            setCommValue(prev => ({ ...prev, [uniqueKey]: calculatedValue }));
        });
    };




    const deleteCommission = (item) => {
        $(".loader").show();
        setDeleteDialogOpen(false);
        Common.callApi(Common.apiModiCommission, [sid, "deletecommission", JSON.stringify(item), JSON.stringify(tranAuditTrail)], function (result) {
            let resp = JSON.parse(result);
            setPProductList(resp.trandetailproduct);
            setTranAuditTrail([]);
            $(".loader").hide();
            // setCommissionDisable(true);
            setPProductList(prevData =>
                prevData.map(row =>
                    row.uniquekey === item.uniquekey
                        ? { ...row, commission_disable: "1" }
                        : row
                )
            );
            setMsgText("Success");
            setMsgBox(true);
            setEditbtnView(true);
        })

    }
    const calcCommission = (value, type, quantity, deno, rate) => {
        var comm = 0;
        if (type === "P") {
            comm = (value * quantity * deno) / 100;
        } else if (type === "R") {
            comm = (quantity * deno * rate) * (value / 100);
        } else {
            comm = value;
        }
        return comm;
    }
    const saveCommission = (item) => {
        $(".loader").show();
        setSaveDialogOpen(false);
        const infoObject = Common.compareArrays(compareData, [item]);
        setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, item.prd_type, ppLocationValue));
        item.unlockRequestType = unlockRequestType;
        Common.callApi(Common.apiModiCommission, [sid, "updatecommission", JSON.stringify(item), JSON.stringify(tranAuditTrail)], function (result) {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.status) {
                setPProductList(resp.trandetailproduct);
                // setCommissionDisable(true);
                setPProductList(prevData =>
                    prevData.map(row =>
                        row.uniquekey === item.uniquekey
                            ? { ...row, commission_disable: "1" }
                            : row
                    )
                );
                console.log(item)
                setMsgBox(true);
                setMsgText("Success");
                expireUnlock(item);
                setEditbtnView(true);
                setTranAuditTrail([]);
            } else {
                setMsgBox(true);
                setMsgText(resp.msg);
            }

        });
    };

    const fillViewCompareObject = (item, pProductList) => {
        const matchedItem = pProductList.find(row => row.uniquekey === item.uniquekey);
        if (matchedItem) {
            setCompareData([matchedItem]);
        } else {
            console.log("Data Nahi mila");
        }
    };

    const expireUnlock = (item) => {
        console.log(unlockRequestType)
        if (unlockRequestType !== "SELF") {
            const obj = {
                srno: item.prd_srno,
                type: item.prd_type,
                status: 'E',
                currentDate: Common.dateYMD(new Date()),
                pageright: 'COMMISSION_MODIFICATION',
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const handleEditRequest = (item) => {
        let isEditable = true;
        //check data unlock 
        //if date difference between created date and current date is less than 2 days then check unlock
        const createdDate = new Date(item.prd_date);//date ->YYYY-MM-DD
        const todayDate = new Date(new Date().toISOString().slice(0, 10));
        const differenceInDays = Math.ceil((todayDate - createdDate) / (1000 * 60 * 60 * 24));
        console.log(differenceInDays)
        if (differenceInDays > Common.commissionModificationEditDateLimit) {//check for unlock
            const obj = {
                srno: item.prd_srno,
                type: item.prd_type,
                pageright: 'COMMISSION_MODIFICATION',
                location: item.prd_location,
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlockforcommimodifi', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setUnlockRequestType(resp.requestsrc);
                if (resp.msg == "unlock") {
                    setPProductList(prevData =>
                        prevData.map(row =>
                            row.uniquekey === item.uniquekey
                                ? { ...row, commission_disable: "0" }
                                : row
                        )
                    );
                    setPProductList(prevData => {
                        fillViewCompareObject(item, prevData);
                        return prevData;
                    });
                    setEditbtnView(false);
                } else {
                    isEditable = false
                    setShowEditRequest(true);
                    setEditLogObject({ trantype: item.prd_type, trannumber: item.prd_srno, location: item.prd_location, tranDate: Common.dateYMD(new Date()) });
                }
            })
        } else {
            setPProductList(prevData =>
                prevData.map(row =>
                    row.uniquekey === item.uniquekey
                        ? { ...row, commission_disable: "0" }
                        : row
                )
            );
            setPProductList(prevData => {
                fillViewCompareObject(item, prevData);
                return prevData;
            });
            setEditbtnView(false);
        }
    };

    const confirmCommission = (item) => {
        var msg = [], i = 0;
        if (item.prd_agent_group === "" || item.prd_agent_ledger === "" || item.prd_commission_type === "" || item.prd_commission_value === "" || item.prd_commission === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (item.prd_agent_group === "" ? "Agent" : '');
            msg[i++] = (item.prd_agent_ledger === "" ? "Agent" : '');
            msg[i++] = (item.prd_commission_type === "" ? "Commission Type" : '');
            msg[i++] = (item.prd_commission_value === "" ? "Commission Value" : '');
            msg[i++] = (item.prd_commission === "" ? "Commission" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setCommissionData(item);
            setSaveDialogOpen(true);
        }

    }
    const confirmdeletion = (item) => {
        setCommissionDataToDelete(item);
        setDeleteDialogOpen(true);
    }
    const btnActivityLog = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.prd_type, trannumber: item.prd_srno, trancategory: "T", location: item.prd_location, subtranno: item.prd_line_no });
    }
    const btnHeaderActivityLog = (item) => {
        setShowActivityLog(true);
        setLogObject({ trantype: item.hdr_type, trannumber: item.hdr_srno, trancategory: "T", location: item.hdr_location, subtranno: item.hdr_line_no });
    }

    const handleHeaderCommissionCalc = (value, index, keyToChange) => {
        headerList[index][keyToChange] = value;
        setHeaderList([...headerList]);
    }

    const HeaderSaveHandler = (val) => {
        $(".loader").show();
        const infoObject = Common.compareArrays(compareHeaderData, [val]);
        setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, filtertransaction, ppLocationValue));
        const obj = {
            srno: ppSrnoTo,
            type: filtertransaction,
            location: ppLocation?.id?.split('^')[1],
            ...val
        }
        Common.callApi(Common.apiModiCommission, [sid, "updateHeaderCommission", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], function (result) {
            let resp = JSON.parse(result);
            $(".loader").hide();
            if (resp.status) {
                setEditbtnView(true);
                setPProductList(resp.trandetailproduct);
                setHeaderList(resp.tranheader);
                setMsgText("Success");
                setMsgBox(true);
                setEditbtnHeaderView(true);
                setTranAuditTrail([]);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        });
    }

    const HeaderEditHandler = (obj) => {
        setCompareHeaderData([{ ...obj }])
        setEditbtnHeaderView(false)
        if (obj.hdr_type === 'SP') {
            setHeaderDisableCondition(true)
        }

    }

    const handleHeaderAgentChange = (agent, index) => {
        const id = agent.id.split('^');
        setHeaderList([{
            ...headerList[index],
            hdr_oth_commission_agent_group: id[1],
            hdr_oth_commission_agent_account: id[2],
            id: agent.id,
            label: agent.label,
        }])
    }

    return (

        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Transaction Modification Commission </h3>
                    </Col>
                </Row>
                {scrMode === '' ?
                    <Row>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={ppLocation}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleLocationChange}
                                    // isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className="col-md-3 col-6">
                                <Form.Label>Transaction</Form.Label>
                                <Form.Select
                                    value={filtertransaction}
                                    onChange={(e) => {
                                        setFiltertransaction(e.target.value);
                                    }}>
                                    <option value="PP">PP</option>
                                    <option value="PB">PB</option>
                                    <option value="SP">SP</option>
                                    <option value="SB">SB</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        <Row>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={10} value={ppSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoFrom)} />
                                </Form.Group>
                            </Col>
                            {/* <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>SrNo To<span className="colorThemeRed">*</span></Form.Label>
                                    <Form.Control type='text' maxLength={10} value={ppSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setPPSrnoTo)} />
                                </Form.Group>
                            </Col> */}
                        </Row>
                        <Row>&nbsp;</Row>

                        <Row>
                            <Col >
                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={applyFilter}> List</Button>
                            </Col>
                            <Col></Col>
                        </Row>
                        <Row>&nbsp;</Row>

                        <Row>
                            <Table responsive bordered striped>
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Isd Code</th>
                                        <th>Isd Name</th>
                                        <th>Denomination</th>
                                        <th>Quantity</th>
                                        <th>Rate</th>
                                        <th>Amount</th>
                                        <th>USD Rate</th>
                                        <th>USD Amount</th>
                                        <th>Prefix</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>&nbsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pProductList.map((item, index) => (
                                        <React.Fragment key={index}>
                                            {/* Product Row */}
                                            <tr>
                                                <td>{item.prd_product}</td>
                                                <td>{item.prd_isd}</td>
                                                <td>{item.isd_name}</td>
                                                <td>{item.prd_deno}</td>
                                                <td>{item.prd_qty}</td>
                                                <td>{item.prd_rate}</td>
                                                <td>{item.prd_amount}</td>
                                                <td>{item.prd_usd_rate}</td>
                                                <td>{item.prd_usd_amount}</td>
                                                <td>{item.prd_prefix}</td>
                                                <td>{item.prd_from}</td>
                                                <td>{item.prd_to}</td>
                                            </tr>
                                            {
                                                item.prd_product === "TT" || item.prd_product === "DD" ? <>
                                                    <tr><td colSpan="13">
                                                        {item.hdr_refno}&nbsp;{item.hdr_ad2ref}&nbsp;{item.hdr_bankrefno}
                                                    </td></tr>
                                                </> : null
                                            }
                                            {/* Commission Row with Editable Fields */}
                                            <tr>
                                                <td colSpan="13">
                                                    <table style={{ width: '100%' }}>
                                                        <thead>
                                                            <tr>
                                                                <th>&nbsp;</th>
                                                                <th>Agent</th>
                                                                <th>Type</th>
                                                                <th>Commission</th>
                                                                <th>Commission Value</th>
                                                                <th>&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className='col-md-1 col-6'>
                                                                    {(userRight.edit === "1" && !editbtnView) ?
                                                                        <span onClick={() => confirmdeletion(item)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span> : null}
                                                                </td>
                                                                <td className='col-md-3 col-6' style={{ position: "absolute" }}>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}

                                                                        value={{ label: item.prd_agent_name, id: item.prd_agent_ledger }}
                                                                        getOptionLabel={e => e.label}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT, DEALER', ppLocationValue)}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={(value) => handleAgentChange(value, item.uniquekey)}
                                                                        isDisabled={item.commission_disable === "1"}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                </td>
                                                                <td className='col-md-2 col-6'>
                                                                    <Form.Select
                                                                        value={item.prd_commission_type}
                                                                        onChange={(e) => commissionTypeChange(e.target.value, item.uniquekey)}
                                                                        disabled={item.commission_disable === "1"}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="P">Paisa</option>
                                                                        <option value="R">Percentage</option>
                                                                        <option value="F">Flat</option>
                                                                    </Form.Select>
                                                                </td>

                                                                <td className='col-md-2 col-6'>
                                                                    <Form.Control
                                                                        type="text"
                                                                        maxLength={5}
                                                                        value={item.prd_commission}
                                                                        onChange={e => handleCommissionCalc(e.target.value, item.uniquekey)}
                                                                        disabled={item.commission_disable === "1"}
                                                                    />
                                                                </td>
                                                                <td className='col-md-2 col-6'>
                                                                    <Form.Control
                                                                        disabled
                                                                        value={item.prd_commission_value}
                                                                    />
                                                                </td>
                                                                <td className='col-md-1 col-6'>
                                                                    {(userRight.edit === "1" && !editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => confirmCommission(item)}>Save</Button>
                                                                        // <span onClick={() => confirmCommission(item)} className='colorThemeBlue pointer'>
                                                                        //     <FontAwesomeIcon icon={faSave} />
                                                                        // </span> 
                                                                        : null}
                                                                    {(userRight.edit === "1" && editbtnView) ?
                                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest(item)}>Edit</Button>
                                                                        // <span onClick={() => handleEditRequest(item)} className='handCursor colorThemeBlue'>
                                                                        //     <FontAwesomeIcon icon={faEdit} />
                                                                        // </span> 
                                                                        : null} &nbsp;
                                                                    <span>
                                                                        <Badge bg="secondary" className="handCursor" onClick={() => btnActivityLog(item)}>Activity Log</Badge>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>


                        </Row>
                        {headerList.length > 0 &&
                            <Row>
                                <Table responsive bordered striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Agent</th>
                                            {/* <th>Account Code</th> */}
                                            <th>Commission Bank/Other Charges</th>
                                            <th>Commission Nostro Charges</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {headerList.map((item, index) => (
                                            <tr key={index} >
                                                {/* <td>{item.hdr_oth_commission_agent_group}</td>
                                            <td>{item.hdr_oth_commission_agent_account}</td> */}
                                                <td className='col-md-1 col-6'></td>
                                                <td className='col-md-3 col-6' style={{ position: "absolute" }}>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={{
                                                            label: item.hdr_tran_source === 'EREMIT' ? item.prdlabel : item.label,
                                                            id: item.hdr_tran_source === 'EREMIT' ? item.prdid : item.id
                                                        }}
                                                        getOptionLabel={e => e.label}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT, DEALER', ppLocationValue)}
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={(value) => handleHeaderAgentChange(value, index)}
                                                        isDisabled={editbtnHeaderView || item.hdr_tran_source == "EREMIT"}
                                                    />
                                                </td>
                                                <td className='col-md-3 col-6'>
                                                    {/* {item.hdr_oth_commission_bank_charges} */}
                                                    <Form.Control
                                                        type="text"
                                                        maxLength={7}
                                                        value={item.hdr_oth_commission_bank_charges || 0}
                                                        onChange={e => handleHeaderCommissionCalc(e.target.value, index, 'hdr_oth_commission_bank_charges')}
                                                        // disabled={item.commission_disable === "1"}
                                                        disabled={editbtnHeaderView}//|| !(item.hdr_type !== 'SP' && item.hdr_tran_source !== 'EREMIT')

                                                    />
                                                </td>
                                                <td className='col-md-3 col-6'>
                                                    {/* {item.hdr_oth_commission_nostro_charges} */}
                                                    <Form.Control
                                                        type="text"
                                                        maxLength={7}
                                                        value={item.hdr_oth_commission_nostro_charges || 0}
                                                        onChange={e => handleHeaderCommissionCalc(e.target.value, index, 'hdr_oth_commission_nostro_charges')}
                                                        disabled={editbtnHeaderView || item.hdr_tran_source !== 'EREMIT'}
                                                    />
                                                </td>
                                                <td className='col-md-1 col-6'>
                                                    {(userRight.edit === "1" && !editbtnHeaderView) ?
                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => HeaderSaveHandler(item)}>Save</Button>
                                                        // <span onClick={() => confirmCommission(item)} className='colorThemeBlue pointer'>
                                                        //     <FontAwesomeIcon icon={faSave} />
                                                        // </span> 
                                                        : null}
                                                    {(userRight.edit === "1" && editbtnHeaderView) ?
                                                        <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => HeaderEditHandler(item)}>Edit</Button>
                                                        // <span onClick={() => handleEditRequest(item)} className='handCursor colorThemeBlue'>
                                                        //     <FontAwesomeIcon icon={faEdit} />
                                                        // </span> 
                                                        : null} &nbsp;
                                                    <span>
                                                        <Badge bg="secondary" className="handCursor" onClick={() => btnHeaderActivityLog(item)}>Activity Log</Badge>
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Row>
                        }
                    </Row> : null}
            </Container>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <DialogYesNo isOpen={isSaveDialogOpen} onYes={(e) => saveCommission(commissionData)} onNo={(e) => setSaveDialogOpen(false)}>
                {saveMsgTextYN}
            </DialogYesNo>
            <DialogYesNo isOpen={isDeleteDialogOpen} onYes={(e) => deleteCommission(commissionDataToDelete)} onNo={(e) => setDeleteDialogOpen(false)}>
                {deleteMsgTextYN}
            </DialogYesNo>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>

        </>
    )
}

export default Modification_commission;

